import { withAsyncLoading } from '../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableNewsDetailsPage = withAsyncLoading(async () => import('./NewsDetailsPage').then((res) => res.NewsDetailsPage));

export { LoadableNewsDetailsPage };
